<p-dialog header="{{ 'ReceiptFormImport.Import' | translate }}" appendTo="body" [(visible)]="isVisible"
  (visibleChange)="dialogVisibleChange($event)" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '50%' }">
  <form [formGroup]="importForm">
    <!-- 匯入資訊表單 -->
    <div *ngIf="loader.status | async" class="loadingMask">
          <p-progressSpinner></p-progressSpinner>
    </div>
    <div class="p-fluid grid">
      <div class="field col-12">
        <label>{{ 'ReceiptFormImport.DocumentNum' | translate }}</label>
        <p-chips formControlName="documentNum" separator="," required="true"></p-chips>
      </div>
      <div class="field col-12">
        <label>{{ 'WarehousingAbnormal.Modal.FailImportReason' | translate }}</label>
        <p-dropdown appendTo="body" formControlName="failImportReason"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [options]="this.deliveryOptions" [filter]="true"
          [showClear]="true"></p-dropdown>
      </div>
      <div class="field col-12">
        <label>{{ 'WarehousingAbnormal.Modal.Remarks' | translate }}</label>
        <input pInputText type="text" formControlName="remarks" />
      </div>
    </div>
    <!-- 功能按鈕 -->
    <div class="grid">
      <div class="col">
        <button [disabled]="loader.status | async" type="button" pButton pRipple (click)="submitImportAd($event)"
          title="{{ 'Common.Button.Confirm' | translate }}" label="{{ 'Common.Button.Confirm' | translate }}"></button>
        <button type="button" pButton pRipple (click)="dialogVisibleChange($event)" title="{{ 'Common.Button.Cancel' | translate }}"
          label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-4"></button>
      </div>
    </div>
  </form>
</p-dialog>
